import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import PlaySetup from "@/pages/PlaySetup";
import GameRoom from "@/pages/GameRoom";
import CreatorsHub from "@/pages/CreatorsHub";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/play" element={<PlaySetup />} />
        <Route path="/join/:code" element={<PlaySetup />} />
        <Route path="/room/:code" element={<GameRoom />} />
        <Route path="/creatorshub" element={<CreatorsHub />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
